export const createScopedEventName = (body: string, scope: string) => {
  return `${body}:${scope}`;
};
